module.exports = __webpack_public_path__ + "img/0.80b5c3f9.jpg";